import React, { useState, useEffect } from 'react';

export default function NetworkStatus() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [showBack, setShowBack] = useState(false);

  useEffect(() => {
    function onOffline() { setOffline(true); setShowBack(false); }
    function onOnline()  { setOffline(false); setShowBack(true); setTimeout(() => setShowBack(false), 3000); }

    window.addEventListener('offline', onOffline);
    window.addEventListener('online',  onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online',  onOnline);
    };
  }, []);

  if (!offline && !showBack) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, display: 'flex', alignItems: 'center', gap: 10,
      background: offline ? '#1a1a1a' : '#1a1a1a',
      border: `1px solid ${offline ? '#F87171' : '#4ADE80'}`,
      borderRadius: 10, padding: '10px 20px', boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      color: '#fff', fontSize: 14, fontFamily: 'Montserrat, sans-serif',
      fontWeight: 500, whiteSpace: 'nowrap',
      animation: 'fadeInUp 0.3s ease',
    }}>
      <span style={{
        width: 8, height: 8, borderRadius: '50%',
        background: offline ? '#F87171' : '#4ADE80',
        flexShrink: 0,
      }} />
      {offline ? 'No internet connection' : 'Back online'}
    </div>
  );
}
